/*
 * @Author: Liu xing wang
 * @Date: 2019-10-23 17:38:25
 */
/*
 * openid、name公用类
 * @author miqiang
 * @date 2019-10-23
 */
export class RespEntityUtil {

    /**
     * 主键id
     */
    public openid: string;
    /**
     * 名称
     */
    public name: string;

    constructor(openid: string, name: string) {
        this.openid = openid;
        this.name = name;
    }
}